// TODO: Contents mostly copied from: https://github.com/creditornot/ops-tools/blob/master/src/modules/merchant-onboarding/views/countryCodes.ts
// Maybe country configurations should be read from API instead of hardcoding?

import countries from 'i18n-iso-countries';
import englishLocale from 'i18n-iso-countries/langs/en.json';

import { BankAccountType } from '../../../apis/legitimizer/types';

type CountryCodeData = {
  code: string;
  name: string;
  nationality: string;
  extension: string;
  flag: string;
  bankAccountTypes: BankAccountType[];
};

countries.registerLocale(englishLocale);

export const flagFromCountryCode = (countryCode: string) =>
  countryCode
    .slice(0, 2)
    .split('')
    .map((a: string) => String.fromCodePoint(0x1f1a5 + a.toUpperCase().codePointAt(0)!))
    .join('');

const allCountries = (locale: string) =>
  Object.entries(countries.getAlpha3Codes())
    .flatMap(([alpha3, alpha2]) => ({
      code: alpha3,
      name: countries.getName(alpha3, locale),
      flag: flagFromCountryCode(alpha2),
    }))
    .filter(c => c.name !== undefined)
    .sort((a, b) => a.name.localeCompare(b.name));

const iban: BankAccountType = 'IBAN';
const bban: BankAccountType = 'BBAN';

const countryCodesData: CountryCodeData[] = [
  {
    code: 'FIN',
    name: 'Finland',
    nationality: 'Finnish',
    extension: '+358',
    flag: '🇫🇮',
    bankAccountTypes: [iban],
  },
  {
    code: 'SWE',
    name: 'Sweden',
    nationality: 'Swedish',
    extension: '+46',
    flag: '🇸🇪',
    bankAccountTypes: [iban],
  },
  {
    code: 'EST',
    name: 'Estonia',
    nationality: 'Estonian',
    extension: '+372',
    flag: '🇪🇪',
    bankAccountTypes: [iban],
  },
  {
    code: 'DNK',
    name: 'Denmark',
    nationality: 'Danish',
    extension: '+45',
    flag: '🇩🇰',
    bankAccountTypes: [bban, iban],
  },
  {
    code: 'LTU',
    name: 'Lithuania',
    nationality: 'Lithuanian',
    extension: '+370',
    flag: '🇱🇹',
    bankAccountTypes: [iban],
  },
  {
    code: 'LVA',
    name: 'Latvia',
    nationality: 'Latvian',
    extension: '+371',
    flag: '🇱🇻',
    bankAccountTypes: [iban],
  },
  {
    code: 'NOR',
    name: 'Norway',
    nationality: 'Norwegian',
    extension: '+47',
    flag: '🇳🇴',
    bankAccountTypes: [iban],
  },
  {
    code: 'GEO',
    name: 'Georgia',
    nationality: 'Georgian',
    extension: '+995',
    flag: '🇬🇪',
    bankAccountTypes: [iban],
  },
  {
    code: 'HUN',
    name: 'Hungary',
    nationality: 'Hungarian',
    extension: '+36',
    flag: '🇭🇺',
    bankAccountTypes: [iban],
  },
  {
    code: 'CZE',
    name: 'Czechia',
    nationality: 'Czech',
    extension: '+420',
    flag: '🇨🇿',
    bankAccountTypes: [iban],
  },
  {
    code: 'POL',
    name: 'Poland',
    nationality: 'Polish',
    extension: '+48',
    flag: '🇵🇱',
    bankAccountTypes: [iban],
  },
  {
    code: 'ISR',
    name: 'Israel',
    nationality: 'Israeli',
    extension: '+972',
    flag: '🇮🇱',
    bankAccountTypes: [iban],
  },
  {
    code: 'GRC',
    name: 'Greece',
    nationality: 'Greek',
    extension: '+30',
    flag: '🇬🇷',
    bankAccountTypes: [iban],
  },
  {
    code: 'HRV',
    name: 'Croatia',
    nationality: 'Croatian',
    extension: '+385',
    flag: '🇭🇷',
    bankAccountTypes: [iban],
  },
  {
    code: 'SRB',
    name: 'Serbia',
    nationality: 'Serbian',
    extension: '+381',
    flag: '🇷🇸',
    bankAccountTypes: [iban, bban],
  },
  {
    code: 'AZE',
    name: 'Azerbaijan',
    nationality: 'Azerbaijani',
    extension: '+994',
    flag: '🇦🇿',
    bankAccountTypes: [iban],
  },
  {
    code: 'SVK',
    name: 'Slovakia',
    nationality: 'Slovak',
    extension: '+421',
    flag: '🇸🇰',
    bankAccountTypes: [iban],
  },
  {
    code: 'SVN',
    name: 'Slovenia',
    nationality: 'Slovenian',
    extension: '+386',
    flag: '🇸🇮',
    bankAccountTypes: [iban],
  },
  {
    code: 'KAZ',
    name: 'Kazakhstan',
    nationality: 'Kazakh',
    extension: '+7',
    flag: '🇰🇿',
    bankAccountTypes: [iban],
  },
  {
    code: 'CYP',
    name: 'Cyprus',
    nationality: 'Cypriot',
    extension: '+357',
    flag: '🇨🇾',
    bankAccountTypes: [iban],
  },
  {
    code: 'JPN',
    name: 'Japan',
    nationality: 'Japanese',
    extension: '+81',
    flag: '🇯🇵',
    bankAccountTypes: [bban],
  },
  {
    code: 'MLT',
    name: 'Malta',
    nationality: 'Maltese',
    extension: '+356',
    flag: '🇲🇹',
    bankAccountTypes: [iban],
  },
  {
    code: 'DEU',
    name: 'Germany',
    nationality: 'German',
    extension: '+49',
    flag: '🇩🇪',
    bankAccountTypes: [iban],
  },
  {
    code: 'ISL',
    name: 'Iceland',
    nationality: 'Icelandic',
    extension: '+354',
    flag: '🇮🇸',
    bankAccountTypes: [iban],
  },
  {
    code: 'AUT',
    name: 'Austria',
    nationality: 'Austrian',
    extension: '+43',
    flag: '🇦🇹',
    bankAccountTypes: [iban],
  },
  {
    code: 'LUX',
    name: 'Luxembourg',
    nationality: 'Luxembourger',
    extension: '+352',
    flag: '🇱🇺',
    bankAccountTypes: [iban],
  },
  {
    code: 'ALB',
    name: 'Albania',
    nationality: 'Albanian',
    extension: '+355',
    flag: '🇦🇱',
    bankAccountTypes: [iban],
  },
].sort((a, b) => a.name.localeCompare(b.name));

export const COUNTRY_CODE_EXTENSIONS = countryCodesData.map(c => {
  return {
    id: c.extension,
    value: `${c.name} ${c.flag} (${c.extension})`,
  };
});

export const COUNTRY_CODES = countryCodesData.map(c => {
  return {
    id: c.code,
    value: `${c.name} ${c.flag}`,
  };
});

export const ALL_COUNTRIES = allCountries('en').map(c => {
  return {
    id: c.code,
    value: `${c.name} ${c.flag}`,
  };
});

export const ALL_NATIONALITIES = ALL_COUNTRIES.concat({ id: 'XXA', value: 'Stateless' });

export const bankAccountTypesForCountry = (countryCode: string) => {
  return (countryCodesData.find(country => country.code === countryCode)?.bankAccountTypes ?? [iban]).map(
    accountType => ({ label: accountType, value: accountType }),
  );
};

export const countryByCode = (countryCode?: string | null) => {
  switch (countryCode) {
    case 'XXA':
      return 'Stateless';
    default:
      return ALL_COUNTRIES.find(country => country.id === countryCode)?.value;
  }
};

const dac7CountryList = [
  'AUT',
  'CYP',
  'CZE',
  'DEU',
  'DNK',
  'EST',
  'FIN',
  'GRC',
  'HRV',
  'LTU',
  'LUX',
  'LVA',
  'MLT',
  'POL',
  'SVK',
  'SVN',
  'SWE',
];

export const isDac7Country = (country: string) => dac7CountryList.includes(country);

export const dac7Countries = ALL_COUNTRIES.filter(country => isDac7Country(country.id));
